import { render, staticRenderFns } from "./ItemPromotion.vue?vue&type=template&id=4dc28194"
import script from "./ItemPromotion.vue?vue&type=script&lang=js"
export * from "./ItemPromotion.vue?vue&type=script&lang=js"
import style0 from "./ItemPromotion.vue?vue&type=style&index=0&id=4dc28194&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports